import {auth, db} from '../datasource'
import '../../domain/IAuth'
import firebase from 'firebase/app';
import 'firebase/auth';
import {User} from '@/domain/entities/User';
import {Patient} from '@/domain/entities/Patient';
// import {pprint} from '@/helpers/pprint';
import {BehaviorSubject} from 'rxjs'
import {pprint} from '@/helpers/pprint';
import {UserType} from '@/domain/entities/UserTypes';
import { IAuth } from '../../domain/IAuth';
import { Doctor } from '@/domain/entities/Doctor';

export enum UserStatus {
	Unknown,
	SignedIn,
	SignedOut
}

export default class AuthFacade implements IAuth {

	static get key() { return  'AuthFacade' }
	_provider: firebase.auth.GoogleAuthProvider;
	get loggedIn(): boolean {return auth.currentUser !== null}
	get user(): firebase.User | null {
		return auth.currentUser
	}

	userBehaviorSubject: BehaviorSubject<UserState> = new BehaviorSubject<UserState>(new UserState(undefined))

	constructor() {
		this._provider = new firebase.auth.GoogleAuthProvider();
		auth.useDeviceLanguage();

		const authStateObserver = (user: firebase.User | null) => {
			if (user) {
				this.userBehaviorSubject.next(new UserState(user))
			}
			else {
				this.userBehaviorSubject.next(new UserState(null))
			}
		}

		firebase.auth().onAuthStateChanged(authStateObserver)
	}

	async logout(): Promise<void> {
		await auth.signOut()
	}

	async login(typeUser : UserType) : Promise<User> {
		try {
			const result = await auth.signInWithPopup(this._provider)
			
			const user : User = {
				id: result.user?.uid || '',
				email: result.user?.email || '',
				typeUser: typeUser,
			}
			console.log('*** user', user)
			if (user.typeUser === UserType.Patient) {

				let patientRef = db.collection('patients').doc(user.id)
				let patientDoc = await patientRef.get()
				if (!patientDoc.exists) {
					const patient = new Patient(user.id)
					patient.email = user.email
					patient.firstName = result.user?.displayName?.split(' ')[0] || ''
					patient.lastName = result.user?.displayName?.split(' ')[1] || ''
					await patientRef.set({
						...patient
					}, { merge: true })
					patientDoc = await patientRef.get()
				}
				let patientData = patientDoc.data()
				console.log('*** patietnData', patientData)
			} else if(user.typeUser === UserType.Doctor) {
				const doctor = new Doctor(user.id, user.email || '')

				let doctorRef = db.collection('doctors').doc(user.id)
				let doctorDoc = await doctorRef.get()
				if (!doctorDoc.exists) {
					await doctorRef.set({
						...doctor
					}, { merge: true })
					doctorDoc = await doctorRef.get()
				}
				let doctorData = doctorDoc.data()
				console.log('*** doctorData', doctorData)
			}
			return user;
		} catch (error) {
			let errorCode = error.code;
			let errorMessage = error.message;
			// The email of the user's account used.
			let email = error.email;
			// The firebase.auth.AuthCredential type that was used.
			let credential = error.credential;
			// ...
			pprint('on error', errorCode, errorMessage, email, credential)
			throw errorCode || errorMessage || email || credential;
		}
	}

}

export class UserState {
	readonly status: UserStatus
	readonly value: firebase.User | undefined | null
	constructor(value: firebase.User | undefined | null) {
		this.status =
			value === undefined ? UserStatus.Unknown :
				value === null ? UserStatus.SignedOut :
					UserStatus.SignedIn
		this.value = value
	}
}


